<template>
  <ClientOnly>
    <div class="tw-pb-14 tw-relative">
      <CommonHeader :is-light="!mdAndUp" class="tw-absolute md:tw-relative tw-top-0 tw-left-0 tw-w-full" />
      <section class="tw-px-0 md:tw-container md:tw-mx-auto">
        <Swiper
          :pagination="{ clickable: true }"
          :modules="modules"
          :spaceBetween="mdAndUp ? 30 : 0"
          class="swiper"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
          }"
        >
          <SwiperSlide
            v-for="(item, index) in banner_cases"
            :key="index"
            :style="{ backgroundColor: item.primaryColors.color }"
            class="md:tw-rounded-2xl md:tw-overflow-hidden tw-min-h-screen md:tw-min-h-fit"
          >
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-pt-20 lg:tw-pt-0">
              <div class="tw-basis-full md:tw-basis-5/12 tw-flex tw-justify-center tw-items-center">
                <div class="tw-flex tw-flex-col tw-p-5 sm:tw-p-8 md:tw-p-10 lg:tw-p-15">
                  <h3
                    class="tw-font-poppins tw-text-white font-weight-light tw-opacity-[3] tw-text-3xl md:tw-text-4xl"
                    style="opacity: 0.3"
                    >{{ $t('show-case') }}</h3
                  >
                  <div class="tw-my-7 sm:tw-my-8 md:tw-my-10 lg:tw-my-14">
                    <NuxtImg :alt="item.key" class="tw-max-h-16" :src="item.logo" />
                  </div>
                  <p class="tw-text-white tw-text-ellipsis tw-leading-relaxed tw-line-clamp-4 tw-text-base md:tw-text-lg !tw-font-normal">
                    {{ item.introduce }}
                  </p>
                  <div class="tw-items-center tw-hidden md:tw-flex tw-mt-10 tw-space-x-10">
                    <UIButton :to="`/cases/${item.key}`" theme="secondary-2" class="tw-btn-lg md:tw-btn-xl tw-uppercase">
                      {{ $t('see-full-case') }}
                      <template #append-inner><svgo-common-arrow-white class="tw-w-2" /> </template
                    ></UIButton>
                    <div
                      class="tw-flex tw-justify-center tw-text-white tw-underline tw-text-nowrap tw-mx-2 tw-cursor-pointer tw-text-base md:tw-text-lg tw-font-semibold tw-transition-all tw-duration-300 tw-ease-in-out tw-underline-offset-2 hover:tw-underline-offset-4 hover:tw-decoration-2"
                      @click="onTouched"
                    >
                      {{ $t('get-in-touch') }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tw-basis-full md:tw-basis-7/12 wow fadeIn tw-flex tw-justify-center md:tw-justify-end tw-items-center"
                data-wow-delay="0.4s"
              >
                <NuxtImg alt="case-view" class="md:tw-hidden tw-max-h-[400px]" :src="item.bannerView" />
                <NuxtImg alt="case-view" class="tw-hidden md:tw-block tw-w-full" :src="item.bannerView" />
              </div>
              <div class="md:tw-hidden wow fadeInUp" data-wow-delay="0.6s">
                <div class="tw-justify-between tw-items-center tw-flex-col sm:tw-flex-row sm:tw-justify-center tw-flex tw-gap-5">
                  <div>
                    <UIButton theme="secondary-2" :to="`/cases/${item.key}`" class="tw-btn-lg md:tw-btn-xl tw-uppercase">
                      {{ $t('see-full-case') }}
                      <template #append-inner>
                        <svgo-common-arrow-white class="tw-w-2 tw-h-2" />
                      </template>
                    </UIButton>
                  </div>
                  <div class="tw-flex tw-justify-center tw-text-white tw-underline tw-cursor-pointer tw-pb-14" @click="onTouched">
                    {{ $t('get-in-touch') }}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
      <section class="tw-bg-mobile md:tw-bg-desktop">
        <div class="tw-container tw-mx-auto">
          <h2 class="tw-font-bold md:tw-font-black tw-text-[40px] md:tw-text-5xl lg:tw-text-6xl tw-text-center tw-my-14 !tw-leading-normal">
            {{ $t('how-we-do') }}
            <span class="tw-italic tw-font-light tw-block sm:tw-inline tw-font-poppins tw-text-[54px]">{{ $t('the-best') }}</span>
          </h2>
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
            <div class="tw-card tw-rounded-2xl tw-bg-white md:tw-pb-12 tw-px-5 tw-py-7 tw-transition-all tw-duration-300 tw-ease-in-out hover:-tw-translate-y-3 hover:tw-shadow-lg hover:tw-border-primary" v-for="(item, index) in partnerList" :key="index">
              <div class="tw-flex tw-justify-center">
                <NuxtImg class="tw-min-w-[120px] tw-max-w-[180px]" :alt="item.name" :src="item.logo" />
              </div>
              <p
                class="tw-text-sm md:tw-text-base tw-mt-2 md:tw-mt-3 tw-text-ellipsis tw-leading-relaxed tw-line-clamp-5 md:tw-line-clamp-4"
                :title="item.name"
              >
                {{ $t(`${item.key}.desc`) }}
              </p>
              <div class="-tw-mx-5">
                <div class="tw-flex tw-flex-col tw-justify-center tw-items-center card-img-layer tw-relative tw-pb-1 tw-pt-5 md:tw-pt-8">
                  <NuxtImg class="w-100 overflow-visible" alt="case-view" :src="item.smallView" />
                  <div class="tw-absolute tw-bottom-0 tw-left-1/2 -tw-translate-x-1/2">
                    <UIButton theme="secondary-1" class="tw-btn-lg tw-text-nowrap" :to="`/cases/${item.key}`">
                      {{ $t('see-full-case') }}
                      <template #append-inner>
                        <svgo-common-arrow-white class="tw-w-2" />
                      </template>
                    </UIButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PartnerShipsBuildWithUs class="tw-mt-14 sm:tw-mt-24 md:tw-mt-32 lg:tw-mt-36" />
        </div>
      </section>
    </div>
  </ClientOnly>
</template>

<script lang="ts" setup>
  import { PARTNERS_PAY } from '~/config'
  import { Pagination, Autoplay } from 'swiper/modules'
  import { Swiper, SwiperSlide } from 'swiper/vue'

  import 'swiper/css'
  import 'swiper/css/pagination'

  const { t } = useI18n()
  const { mdAndUp } = useDisplay()
  const zenDesk = useZenDesk()
  const onTouched = () => {
    zenDesk.onToggle()
  }

  const dataList = ['kucoin', 'gateio', 'phemex', 'bybit', 'cobo', 'bitrue', 'ellipal', 'bitmart', 'zoomex', 'lbank', 'xbank']
  const partnerList = computed(() => PARTNERS_PAY.filter(({ key }) => dataList.includes(key)))
  const modules = [Pagination, Autoplay]


  const banner_cases = computed(() => [
    {
      key: 'kucoin',
      primaryColors: {
        color: '#23af91',
      },
      logo: `/res/logo-partners/Exchanges Wallets/kucoin-white.svg`,
      bannerView: `/res/img/cases/kucoin-view-2.png`,
      introduce: t('kucoin-introduce'),
    },
    // {
    //   key: 'gateio',
    //   primaryColors: {
    //     color: '#2354e6',
    //   },
    //   logo: `/res/logo-partners/Exchanges Wallets/gateio-white.svg`,
    //   bannerView: `/res/img/cases/gateio-view-1.png`,
    //   introduce: t('gateio-introduce'),
    // },
  ])
</script>

<style scoped lang="scss">
  .cases {
    .swiper-box {
      position: relative;
      margin-top: -90px;

      .swiper-slide {
        background-image: radial-gradient(circle at 13% 24%, hsla(0, 0%, 100%, 0.2), hsla(0, 0%, 100%, 0) 40%);
        padding-top: 90px;
        border-radius: 0px;
        height: 800px;
      }
    }

    @media (min-width: 960px) {
      .swiper-box {
        position: relative;
        margin-top: 0px;

        .swiper-slide {
          padding-top: 0px;
          height: auto;
          border-radius: 30px;
          height: 600px;
          display: flex;
        }
      }
    }
  }
  .card-img-layer {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 60%;
      top: 40%;
      left: 0;
      z-index: -1;
      background: linear-gradient(180deg, #ffffff 16.09%, rgba(255, 255, 255, 0) 100%);
      transform: matrix(1, 0, 0, -1, 0, 0);
    }
  }
</style>
